module.exports = __webpack_public_path__ + "img/pear.70fbde3a.svg";